module.exports = __webpack_public_path__ + "img/标题_左.9ae1ff1f.svg";